import {
  ITokenValidationResponse,
  IUserDataResponse,
} from '../models/auth.models';
import { AuthApiService } from '../services/auth-api.service';
import { AccountApiService } from './../services/account-api.service';
import { effect, inject, Injectable, signal } from '@angular/core';
import { UserClient, UserDataService } from '@ribera-web/user-data-access';
import { UserTypeStateService } from './user-type-state.service';
import { ShellDataService } from './shell-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserDataStateService {
  private accountApiService = inject(AccountApiService);
  private authApiService = inject(AuthApiService);
  private userTypeService = inject(UserTypeStateService);
  private shellDataService = inject(ShellDataService);

  private readonly userDataService = inject(UserDataService);

  userDataResponse = signal<IUserDataResponse | null>(null);
  userIdResponse = signal<number | null>(null);
  error = signal<string | null>(null);
  isLoading = signal(false);
  hasError = signal(false);

  userData = signal<UserClient | null>(null);

  userProfileImage = signal<string>('/member/dashboard/user-image-default.png');

  constructor() {
    console.log('[UserDataStateService] Servicio de estado inicializado.');
    effect(() => {
      const id = this.userIdResponse();

      if (id) {
        console.log('🔄 userId cambió, cargando imagen...');
        this.loadProfileImage(id);
      }
    });
  }

  loadContextApp() {
    this.shellDataService.isPromotorPerfil.set(this.userTypeService.isPromotor());
  }

  loadDataUser(){

    const token = localStorage.getItem('accessToken');

    if (token) {
      console.log('🔄 Reconstruyendo sesión después de refresh');
      this.getUserIdByToken(token);
    }
  }

  getUserData(id: number) {
    console.log('📥 [SERVICE-GET-DATA] Obteniendo datos íntegros...');
    // this.isLoading.set(true);

    this.accountApiService.getUserById(id).subscribe({
      next: (res: IUserDataResponse) => {
        this.loadProfileImage(id);
      },
      error: () => {
        console.log('[UserDataStateService] No hay imagen, usando default');
        this.resetImage();
      }
    });
  }

  getUserIdByToken(token: string) {
    if (this.userIdResponse()) {
      console.log('[UserDataStateService ] Token ya validado previamente. Saltando...');
      return;
    }

    this.authApiService.validateToken(token).subscribe({
      next: (res: ITokenValidationResponse) => {
        if (res.data?.result) {
          const newId = res.data.id;
          this.isLoading.set(false);
          this.userIdResponse.set(res.data.id);
          this.loadCompleteUserProfile(newId);
          this.error.set(null);
          this.hasError.set(false);
        }
      },
      error: (err) => {
        console.error('[UserDataStateService ] Error validando token:', err);
        this.isLoading.set(false);
        this.error.set('Error al obtener el id del usuario.');
        this.userDataResponse.set(null);
        this.hasError.set(true);
      },
    });
  }

  updateStateImage(url: string): void {
    this.userProfileImage.set(url);
  }

  resetImage(): void {
    this.userProfileImage.set('/member/dashboard/Mask group.svg');
  }

  private loadCompleteUserProfile(id: number) {
    if (this.userData()) {
       console.log('[UserDataStateService ] Datos ya presentes en estado. Saltando...');
       return;
    }
    console.log(`[UserDataStateService ] Cargando datos completos para userId ${id}...`);
    this.isLoading.set(true);

    this.userDataService.getUserClientById(id).subscribe({
      next: (user: UserClient) => {
        this.userData.set(user);
        this.loadProfileImage(id);
        this.isLoading.set(false);
      }
    });
  }

  private loadProfileImage(id: number) {
    this.userDataService.getUserProfileImage(id).subscribe({
          next: (res) => {
            const url = res.url || '/member/dashboard/Mask group.svg';
            this.userProfileImage.set(url);
          },
          error: () => this.resetImage()
        });
  }
}
